export const displayTabNames: Record<string, string> = {
  All: "All",
  Approved: "Approved",
  ApprovedConditionally: "Approved conditionally",
  Canceled: "Canceled",
  Declined: "Declined",
  Invited: "Invited",
  NotSubmitted: "Not submitted",
  OnHold: "On hold",
  PartiallySubmitted: "Partially submitted",
  Pending: "Pending decision",
  Started: "In progress",
  Submitted: "Submitted"
};
